import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface Props {
    sx?: Object,
};

const Logo: React.FC<Props> = ({ sx }) => {
    return <img src="/static/illustrations/logo_blue.svg" style={{ width: 124, height: 48 }} />;
}

export default Logo;